import { render, staticRenderFns } from "./CertificateCourse.vue?vue&type=template&id=01fec4fb&scoped=true"
import script from "./CertificateCourse.vue?vue&type=script&lang=js"
export * from "./CertificateCourse.vue?vue&type=script&lang=js"
import style0 from "./CertificateCourse.vue?vue&type=style&index=0&id=01fec4fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fec4fb",
  null
  
)

export default component.exports